// export const BASE_URL = "https://stage.luckyduckgroup.com/Admin/api";
// export const Image_Base_URL =
//   "https://stage.luckyduckgroup.com/Admin/storage/app/public/";

// export const BASE_URL = "https://luckyduckgroup.com/Admin/api";
// export const Image_Base_URL =
//   "https://luckyduckgroup.com/Admin/storage/app/public/";

// const ENV = process.env.REACT_APP_ENV || "development";

// export const BASE_URL =
//   process.env.REACT_APP_API_BASE_URL ||
//   "https://stage.luckyduckgroup.com/Admin/api";
// export const Image_Base_URL =
//   process.env.REACT_APP_IMAGE_BASE_URL ||
//   "https://stage.luckyduckgroup.com/Admin/storage/app/public/";

const ENV = process.env.REACT_APP_ENV || "development";

// console.log(ENV);

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://stage.luckyduckgroup.com/Admin";
export const Image_Base_URL = process.env.REACT_APP_IMAGE_BASE_URL || "https://stage.luckyduckgroup.com/Admin/storage/app/public/";

//console.log(`Running in ${ENV} mode with API: ${API_BASE_URL}`);

const apiUrls = {
  propertiesOngoingInv: `${BASE_URL}/propertiesongoingInv`,
  propertiesCompleteInv: `${BASE_URL}/propertiescompleteInv`,
  builderBanner: `${BASE_URL}/builder-banner`,
  buildingStrategy: `${BASE_URL}/building-strategy`,
  callToAction: `${BASE_URL}/call-to-action`,
  bottomBanner: `${BASE_URL}/bottom-banner`,
  buildProperties: `${BASE_URL}/buildProperties`,
  careerCms: `${BASE_URL}/careerCms`,
  jobs: `${BASE_URL}/jobs`,
  contactCms: `${BASE_URL}/contactCms`,
  propertiesCloseInv: `${BASE_URL}/propertiescloseInv`,
  propertiesOpenInv: `${BASE_URL}/propertiesopenInv`,
  developmentBanner: `${BASE_URL}/development-banner`,
  investmentStrategy: `${BASE_URL}/investment-strategy`,
  footers: `${BASE_URL}/footers`,
  Philosophy: `${BASE_URL}/philosophy`,
  aboutBanners: `${BASE_URL}/about-banners`,
  aboutContentGrowth: `${BASE_URL}/about-content/growth`,
  aboutContentValues: `${BASE_URL}/about-content/values`,
  team: `${BASE_URL}/team`,
  partners: `${BASE_URL}/advisory_partners`,
  aboutContentMission: `${BASE_URL}/about-content/mission`,
  landingBanners: `${BASE_URL}/landing-banners`,
  marketOpportunities: `${BASE_URL}/market-opportunities`,
  expertise: `${BASE_URL}/expertise`,
  offerings: `${BASE_URL}/offerings`,
  privacyPolicy: `${BASE_URL}/privacy-policy`,
  Visitors: `${BASE_URL}/visitors`,
  PropertyManagementBanner: `${BASE_URL}/property-management`,
  PropertySolutions: `${BASE_URL}/property-management-service`,
  PropertyMgmntCta: `${BASE_URL}/property-management-call-to-action`,
  PropertyMgmntproperties: `${BASE_URL}/property-property-listing`,
  videoTour: `${BASE_URL}/video-tours`,
  PropertyMgmntListingtitle: `${BASE_URL}/property-section-title`,
  builderCallToAction: `${BASE_URL}/builder-call-to-action/api`,
  advisoryServicesBannerText: `${BASE_URL}/advisory-services-banner-text`,
  advisoryContentSection: `${BASE_URL}/advisory-services-content-section`,
  advisoryServiceIncludes: `${BASE_URL}/our-advisory-service-include`,
  advisorychoose: `${BASE_URL}/advisory-service-why-choose`,
  advisorycontactus: `${BASE_URL}/advisory-service-cta`,
  investorRelationBanner: `${BASE_URL}/investor-relation-banner`,
  investorRelationSteps: `${BASE_URL}/investor-relation-steps`,
  investorRelationFundingTimeline: `${BASE_URL}/investor-relation-funding-timeline`,
  insightsBanner: `${BASE_URL}/blog-banners`,
  insightsBlog: `${BASE_URL}/insight-blogs`,
  insightsDetailsCta: `${BASE_URL}/insight-details-cta`,
  insightContactBanner: `${BASE_URL}/insight-contact-banner`,
  insightContactCta: `${BASE_URL}/insight-contact-cta`,
  insightCalendly : `${BASE_URL}/insight-blog-calendly`,
};

export default apiUrls;
